<template>
    <div>
            <div class="card border-0 m-b-10">
                <div class="card-body">
                    <p class="card-text" v-text="internationalActivityGet['mainText_'+languageGet]"></p>
                    <h4 class="card-title" v-text="internationalActivityGet['direction_'+languageGet]"></h4>
                    <div class="card-text">
                        <div class="row">
                            <div class="col-xl-4 col-sm-6 m-b-5" :key="index"
                                 v-for="(item,index) in internationalActivityGet.directionData">
                                <div class="card border-0 bg-dark text-white">
                                    <img class="card-img-top img-fluid rounded" :src="item.path" alt="" style="opacity:0.5;">
                                    <div class="card-img-overlay">
                                        <p class="card-text" v-text="item[languageGet]"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="card-text" v-text="internationalActivityGet['colleges_'+languageGet]"></p>
                    <div class="card-text">
                        <div class="row">
                            <div class="col-lg-3 col-sm-6 col-6" v-for="(item,index) in internationalActivityGet.colleges_data" :key="index">
                                <a href="javascript:;" class="widget-card widget-card-rounded square m-b-2">
                                    <div class="widget-card-cover" :style="'background-image: url('+item+');'"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: mapGetters(["languageGet","internationalActivityGet"]),
    }
</script>